import {useEffect, useState} from 'react'
import {QueryStatus} from 'src/types'
import {HttpNotificacion} from "../api/httpNotificacion";
import {NotificacionVistaDTO} from "../api/schemas";

export const useNotificaciones = () => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [notificaciones, setNotificaciones] = useState<NotificacionVistaDTO[]>([])

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpNotificacion.getNotificacionesPorUsuario()
            .then(data => {
                setNotificaciones(data)
                setStatus(QueryStatus.Success)
            })
            .catch((e) => {
                console.log(e)
            })
    }, [])

    return {status, notificaciones}
}
